import React from "react";

export function DashboardSection() {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Future dashboard content can go here */}
      </div>
    </div>
  );
}